import { Grid, Tooltip, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { onDownloadFileFromCreator } from '../../helpers/filesHelpers/downloadFiles';
import {
  noFileText,
  TextAsLink,
  titleDiv,
  UploadedDocument,
  uploadedFilesGrid,
} from '../../styles';
import FileUpload from '../atoms/file-upload';
import Toast from '../atoms/toast';

function OverviewUploadFiles(props) {
  const {
    shouldDisableForm,
    displayFiles,
    setDisplayFiles,
    uploadedFiles,
    setUploadedFiles,
    errorMessage,
    setErrorMessage,
    removeDoc,
    onDownload,
  } = props;
  const { t } = useTranslation();

  return (
    <>
      <Grid item xs={6}>
        {shouldDisableForm ? (
          <Grid style={titleDiv}>
            <Grid style={uploadedFilesGrid}>
              <Grid style={UploadedDocument}>{t('Uploaded_Document')}:</Grid>
              <Grid style={UploadedDocument}>
                {Array.isArray(displayFiles) && displayFiles.length > 0 ? (
                  displayFiles.map((document, index) => {
                    return (
                      <Tooltip
                        key={index}
                        title={document}
                        componentsProps={{
                          tooltip: {
                            sx: {
                              fontSize: '14px',
                            },
                          },
                        }}
                      >
                        <Typography
                          key={index}
                          noWrap
                          width={300}
                          style={TextAsLink}
                          onClick={() => onDownload(document)}
                        >
                          {document}
                        </Typography>
                      </Tooltip>
                    );
                  })
                ) : (
                  <Grid style={noFileText}>
                    {t('No_files_have_been_uploaded')}:
                  </Grid>
                )}
              </Grid>
            </Grid>
          </Grid>
        ) : (
          <FileUpload
            displayFiles={displayFiles}
            setDisplayFiles={setDisplayFiles}
            uploadedFiles={uploadedFiles}
            setUploadedFiles={setUploadedFiles}
            errorMessage={errorMessage}
            setErrorMessage={setErrorMessage}
            removeDoc={removeDoc}
            marginLeft={'1.5rem'}
            disabled={shouldDisableForm}
          />
        )}
      </Grid>
      <Toast />
    </>
  );
}

OverviewUploadFiles.propTypes = {
  shouldDisableForm: PropTypes.bool.isRequired,
  displayFiles: PropTypes.array.isRequired,
  setDisplayFiles: PropTypes.func.isRequired,
  uploadedFiles: PropTypes.array.isRequired,
  setUploadedFiles: PropTypes.func.isRequired,
  errorMessage: PropTypes.string.isRequired,
  setErrorMessage: PropTypes.func.isRequired,
  removeDoc: PropTypes.func.isRequired,
  pecrId: PropTypes.string.isRequired,
  onDownload: PropTypes.func.isRequired,
};

export default OverviewUploadFiles;
